/**
 * Capitalizes the first letter of each word in a string.
 * @example capitalizeName("lucas brown") -> "Lucas Brown"
 * @example capitalizeName("john o'connor") -> "John O'Connor"
 */
export const capitalizeName = (name) => {
    if (!name)
        return "";
    return name
        .toLowerCase()
        .split(" ")
        .map((word) => {
        if (!word)
            return "";
        // Handle names with apostrophes (e.g., O'Connor, McDonald)
        if (word.includes("'")) {
            return word
                .split("'")
                .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
                .join("'");
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
    })
        .join(" ");
};
/**
 * Converts a string to sentence case (first letter uppercase, rest lowercase).
 * @example toSentenceCase("JOHN") -> "John"
 * @example toSentenceCase("SMITH") -> "Smith"
 */
export const toSentenceCase = (s) => {
    if (!s || !s.trim())
        return "";
    const t = s.trim();
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
};
/**
 * Formats a full name from first and last name, with proper capitalization.
 * @example formatFullName("lucas", "brown") -> "Lucas Brown"
 */
export const formatFullName = (firstName, lastName) => {
    const first = capitalizeName(firstName);
    const last = capitalizeName(lastName);
    if (first && last) {
        return `${first} ${last}`;
    }
    return first || last || "";
};
export function getContactDisplayName(firstNameOrContact, lastName, email) {
    const isContactObj = typeof firstNameOrContact === "object" &&
        firstNameOrContact !== null &&
        !Array.isArray(firstNameOrContact);
    if (isContactObj) {
        const contact = firstNameOrContact;
        const fullName = formatFullName(contact.firstName, contact.lastName);
        if (fullName)
            return fullName;
        if (contact.name?.trim())
            return capitalizeName(contact.name);
        return contact.email || "";
    }
    const first = firstNameOrContact;
    const fullName = formatFullName(first, lastName);
    return fullName || email || "";
}
